module.exports = __webpack_public_path__ + "static/media/node_logo.26bdcd15.png";